export const VIEWPORT_BREAKPOINT_550: number = 550;
export const VIEWPORT_BREAKPOINT_768: number = 768;
export const VIEWPORT_BREAKPOINT_992: number = 992;
export const VIEWPORT_BREAKPOINT_1200: number = 1200;
